import '../include/allpages';

//used cars used (index)
import {responsiveTabs} from 'responsive-tabs'
import {prepareSearchFilter} from '../include/quickSelectionAutoFormUsed'
import '../include/used-rows';
import {LoadMore} from '../include/loadMore';
import {jsText} from '../include/jsText'


//car id page
import {lightGallery} from 'lightgallery';
import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation/navigation';
import Pagination from 'swiper/modules/pagination/pagination';
import FreeMode from 'swiper/modules/free-mode/free-mode';
import Autoplay from 'swiper/modules/autoplay/autoplay';
import '../include/WidgetSkyCreditFormStep'



//used cars used (index)
$(function () {
    loadMore();
    prepareSearchFilter();
    initTabs();
    showMoreBrandname();
    addHandlersToCheckboxes();
});

function loadMore() {
    LoadMore.init(function (html, $button) {
        var $html = $(html);
        $button.after($html);
        window.initEasyPieChart($html);
        window.initSlider($html);
        jsText($html);
    });
}

function initTabs() {
    let activeTab = 0;
    if (window.WidgetUsedTabs !== undefined) {
        let tab = $(`#tabs_v1 ul li:eq(${window.WidgetUsedTabs.selectedTab})`).length;
        activeTab = tab ? window.WidgetUsedTabs.selectedTab : 0;
    }

    $('#tabs_v1').responsiveTabs({
        startCollapsed: 'tabs',
        active: activeTab,
    });
}


function showMoreBrandname() {

    $('.showMore-box').each(function () {
        let boxHeight = $(this).outerHeight();
        let boxHeightClose = $(this).data('height');
        if (boxHeight > boxHeightClose) {
            $(this).addClass('closed');
            $(this).css('height', boxHeightClose + 'px');
            $(this).data('full-height', boxHeight);
            //$(this).after("<a class='showMore-btn closed'>Еще...</div>");
        }
    });
    $('.showMore-btn').on('click', function () {
        var parent = $(this).prev();
        if ($(parent).hasClass('closed'))
        {
            $(parent).css('height', $(parent).data('full-height') + 'px');
            //$(this).text('Свернуть');
            
        }
        else
        {
            $(parent).css('height', $(parent).data('height') + 'px');
            //$(this).text('Еще...');
        }

        $(parent).toggleClass('closed');
        $(parent).toggleClass('open');
        return false;
    });

}


//used cars car id

$(document).ready(function(){
    window.WidgetSkyCreditFormStep.init();
    if ($("#creditFormId").length > 0)
    {
     //подставляем цену в кредитынй калькулятор
     window.WidgetSkyCreditFormStep.changePrice($("#sum_price_new").text());
     //console.log($("#creditFormCarPrice").text());
     //подставляем значения в форму обратной связи
     
    }
});


//general styles

$(document).ready(function(){
      mobileView();
});
$(window).resize(function(){
      mobileView();
});
function  mobileView() {
      if ($(window).width() <= 840) { 
        if ($("#creditFormView_credit").closest(".credit_left").length == 0) 
        {
            
            $("#creditFormView_credit").insertAfter(".fied-group.elements:eq(1)");
        }
      }
      else
      {
        if ($("#creditFormView_credit").closest(".credit_left").length > 0) 
        {
            $("#creditFormView_credit").insertAfter("#creditForm_credit");
            
        }        
      }
}      




const isMobile = {
   Android: function () { return navigator.userAgent.match(/Android/i) },
   BlackBerry: function () { return navigator.userAgent.match(/BlackBerry/i) },
   iOS: function () { return navigator.userAgent.match(/iPhone|iPad|iPod/i) },
   Opera: function () { return navigator.userAgent.match(/Opera Mini/i) },
   Windows: function () { return navigator.userAgent.match(/IEMobile/i) },
   any: function () {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
   }
};
const isPC = !isMobile.any();
if (isPC) { document.body.classList.add('_pc') } else { document.body.classList.add('_touch') };

// медиазапрос
const MIN768 = window.matchMedia('(min-width: 768px)');
const MIN840 = window.matchMedia('(min-width: 840px)');


function throttle(callee, timeout) {
   let timer = null;
   return function perform(...args) {
      if (timer) return;
      timer = setTimeout(() => {
         callee(...args);
         clearTimeout(timer);
         timer = null;
      }, timeout)
   }
}

const CATALOG_SORT_BUTTON = document.querySelectorAll('.catalog-block__sort-button');
document.body.addEventListener('click', (event) => {
   if (event.target.closest('.catalog-block__sort-button')) {
      let buttonEvent = event.target.closest('.catalog-block__sort-button');
      if (buttonEvent.classList.contains('active')) {
         buttonEvent.classList.toggle('reverse');
         return;
      }
      CATALOG_SORT_BUTTON.forEach((e) => { e.classList.toggle('active', buttonEvent == e) })
   }
})
// перемещение блоков при адаптиве по данным атрибута 
// data-da=".class,3,768" 
// класс родителя куда перемещать
// порядковый номер в родительском блоке куда перемещается начиная с 0 как индексы массива
// ширина экрана min-width
// два перемещения: data-da=".class,3,768,.class2,1,1024"
const ARRAY_DATA_DA = document.querySelectorAll('[data-da]');
ARRAY_DATA_DA.forEach(function (e) {
   const dataArray = e.dataset.da.split(',');
   const addressMove = searchDestination(e, dataArray[0]);
   const addressMoveSecond = dataArray[3] && searchDestination(e, dataArray[3]);
   const addressParent = e.parentElement;
   const listChildren = addressParent.children;
   const mediaQuery = window.matchMedia(`(min-width: ${dataArray[2]}px)`);
   const mediaQuerySecond = dataArray[5] && window.matchMedia(`(min-width: ${dataArray[5]}px)`);
   for (let i = 0; i < listChildren.length; i++) { !listChildren[i].dataset.n && listChildren[i].setAttribute('data-n', `${i}`) };
   mediaQuery.matches && startChange(mediaQuery, addressMove, e, listChildren, addressParent, dataArray);
   if (mediaQuerySecond && mediaQuerySecond.matches) moving(e, dataArray[4], addressMoveSecond);
   mediaQuery.addEventListener('change', () => { startChange(mediaQuery, addressMove, e, listChildren, addressParent, dataArray) });
   if (mediaQuerySecond) mediaQuerySecond.addEventListener('change', () => {
      if (mediaQuerySecond.matches) { moving(e, dataArray[4], addressMoveSecond); return; };
      startChange(mediaQuery, addressMove, e, listChildren, addressParent, dataArray);
   });
});

function startChange(mediaQuery, addressMove, e, listChildren, addressParent, dataArray) {
   if (mediaQuery.matches) { moving(e, dataArray[1], addressMove); return; }
   if (listChildren.length > 0) {
      for (let z = 0; z < listChildren.length; z++) {
         if (listChildren[z].dataset.n > e.dataset.n) {
            listChildren[z].before(e);
            break;
         } else if (z == listChildren.length - 1) {
            addressParent.append(e);
         }
      }
      return;
   }
   addressParent.prepend(e);
};

function searchDestination(e, n) {
   if (e.classList.contains(n.slice(1))) { return e }
   if (e.parentElement.querySelector(n)) { return e.parentElement.querySelector(n) };
   return searchDestination(e.parentElement, n);
}

function moving(e, order, addressMove) {
   if (order == "first") { addressMove.prepend(e); return; };
   if (order == "last") { addressMove.append(e); return; };
   if (addressMove.children[order]) { addressMove.children[order].before(e); return; }
   addressMove.append(e);
}



function swiperActive(media, func) {
   let swiperState = false;
   let swiper;
   function stateSwiper() {
      if (!media.matches) {
         if (!swiperState) {
            swiperState = true;
            swiper = func();
         }
      } else {
         if (swiperState) {
            swiperState = false;
            swiper.destroy(true, true);
         }
      }
   }
   return stateSwiper;
}

function controlSwiper(name, media, func) {
   if (document.querySelector(name)) {
      const initSlider = swiperActive(media, func);
      initSlider();
      window.addEventListener('resize', () => {
         initSlider();
      })
   }
}
function initSwiperBrand() {
   return new Swiper('.popular__swiper', {
      keyboard: {
         enabled: true,
         onlyInViewport: true,
      },
      modules: [Navigation, Pagination, FreeMode],
      allowTouchMove: true,
      loop: true,
      speed: 300,
      slidesPerView: 1,
      spaceBetween: 24,
      pagination: {
         el: '.popular__pagination',
         clickable: true,
      },
   });
}

function initSwiperTabletModels() {
   return new Swiper('.table-models__swiper', {
      keyboard: {
         enabled: true,
         onlyInViewport: true,
      },
      modules: [Navigation, Pagination, FreeMode],      
      allowTouchMove: true,
      loop: false,
      speed: 300,
      slidesPerGroup: 1,
      slidesPerView: 2,
      spaceBetween: 24,
      freeMode: {
         enabled: true,
         sticky: true,
      },
      pagination: {
         el: '.table-models__pagination',
         clickable: true,
      },
      breakpoints: {
         600: {
            slidesPerView: 3,
         }
      }
   });
}

controlSwiper('.popular__swiper', MIN768, initSwiperBrand);
controlSwiper('.table-models__swiper', MIN840, initSwiperTabletModels);

if (document.querySelector('.product-card__swiper')) {
   let swiper = new Swiper('.product-card__swiper', {
      keyboard: {
         enabled: true,
         onlyInViewport: true,
      },
      modules: [Navigation, Pagination],     
      allowTouchMove: true,
      loop: true,
      speed: 300,
      slidesPerView: 1,
      spaceBetween: 24,
      pagination: {
         el: '.product-card__pagination',
         clickable: true,
      },
      navigation: {
         nextEl: '.product-card__swiper-next',
         prevEl: '.product-card__swiper-prev',
      }
   });
}

if (document.querySelector('.swiper-other__swiper')) {
   let swiper = new Swiper('.swiper-other__swiper', {
      keyboard: {
         enabled: true,
         onlyInViewport: true,
      },
      modules: [Navigation, Pagination, FreeMode],      
      allowTouchMove: true,
      loop: true,
      speed: 300,
      slidesPerView: 1,
      spaceBetween: 24,
      pagination: {
         el: '.product-card__pagination',
         clickable: true,
      },
      navigation: {
         nextEl: '.swiper-other__next',
         prevEl: '.swiper-other__prev',
      },
      breakpoints: {
         768: {
            slidesPerView: 3,
         },
         992: {
            slidesPerView: 4,
         }
      }
   });

}

let checkboxData = {
    'credit_10_check': {
        onCheck: function () {
            $('#credit_10_check').closest('.box').attr('data-state', 'on');

            $('#credit_check').closest('.box').attr('data-state', 'off');
            $('#credit_check').prop('checked', false);
        },
        onUncheck: function () {
            $('#credit_10_check').closest('.box').attr('data-state', 'off');
        },
    },
    'credit_check': {
        onCheck: function () {
            $('#credit_10_check').prop('checked', false);
            $('#credit_10_check').closest('.box').attr('data-state', 'off');

            $('#credit_check').closest('.box').attr('data-state', 'on');
            $('#credit_check').closest('.box').find(".discount-value").addClass('active');
        },
        onUncheck: function () {
            $('#credit_check').closest('.box').attr('data-state', 'off');
            $('#credit_check').closest('.box').find(".discount-value").removeClass('active');
        }
    },
    'tradein_check': {
        onCheck: function () {
            $('#tradein_check').closest('.box').attr('data-state', 'on');
            $('#tradein_check').closest('.box').find(".discount-value").addClass('active');
        },
        onUncheck: function () {
            $('#tradein_check').closest('.box').attr('data-state', 'off');
            $('#tradein_check').closest('.box').find(".discount-value").removeClass('active');
        }
    },
};

function addHandlersToCheckboxes() {
    for (let id in checkboxData) {

        $(`#${id}`).click(function (e) {
            let checkboxId = $(this).attr('id');
            let checked = $(this).prop('checked');
            let checkbox = checkboxData[checkboxId];

            if (checked) {
                if (typeof checkbox.onCheck === 'function') {
                    checkbox.onCheck();
                }
            } else {
                if (typeof checkbox.onUncheck === 'function') {
                    checkbox.onUncheck();
                }
            }

            calcUsedPrice();
        });
    }
}

function calcUsedPrice() {
    let salePrice = $('.new-price').data('used-price');
    let creditFlag = $('#credit_check').prop('checked');
    let credit = $('[data-credit]').data('credit');
    let tradeinFlag = $('#tradein_check').prop('checked');
    let tradein = $('[data-tradein]').data('tradein');

    let priceWithDiscount = salePrice;
    if (creditFlag) {
        priceWithDiscount -= credit;
    }
    if (tradeinFlag) {
        priceWithDiscount -= tradein;
    }

    $('#sum_price_new').text('' + prettyNumber(priceWithDiscount) + ' ₽');
}
